module.exports = __webpack_public_path__ + "static/media/booking_art.f238829a.jpg";